import { getLoggedInUser } from 'selectors/app_state';
import getPresence from 'utilities/getPresence';

const presenceValues = {
  Online: 1,
  Unavailable: 2,
  Offline: 3,
};

const getTeamStatus = (team, agentTeams, agents) => {
  const memberIDs = agentTeams
    .filter((item) => item.team_id === team.id)
    .map((item) => item.agent_id);
  const memberStatuses = agents
    .filter((agent) => memberIDs.indexOf(agent.id) > -1)
    .map((agent) =>
      getPresence(agent.presence, agent.web_available || agent.mobile_available)
    );
  let teamStatus;
  if (memberStatuses.indexOf('Online') > -1) {
    teamStatus = 'Online';
  } else if (memberStatuses.indexOf('Unavailable') > -1) {
    teamStatus = 'Unavailable';
  } else {
    teamStatus = 'Offline';
  }
  return teamStatus;
};

const sortTeamName = (teamA, teamB) => {
  var nameA = teamA.label.toUpperCase();
  var nameB = teamB.label.toUpperCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
};

const sortLoggedInUserTeams = (teamA, userTeams) => {
  if (userTeams.includes(teamA.team.id)) return -1;
  return 1;
};

const sortTeamPresence = (userTeams) => (teamA, teamB) => {
  if (userTeams.includes(teamA.team.id) || userTeams.includes(teamB.team.id)) {
    return sortLoggedInUserTeams(teamA, userTeams);
  }
  if (teamA.presence === teamB.presence) {
    return sortTeamName(teamA, teamB);
  }
  return presenceValues[teamA.presence] - presenceValues[teamB.presence];
};

export const getLoggedInUsersTeamIds = (state) => {
  const agentTeams = state.agent_teams;
  const loggedInUserId = getLoggedInUser(state)?.id;
  const isForLoggedInUser = (agentTeamRelation) =>
    agentTeamRelation.agent_id === loggedInUserId;
  const getTeamId = (agentTeamRelation) => agentTeamRelation.team_id;
  return agentTeams.filter(isForLoggedInUser).map(getTeamId);
};

export const getLoggedInUsersTeams = (state) => {
  const teamIds = getLoggedInUsersTeamIds(state);
  const teams = state.teams;
  const findTeamById = (id) => teams.find((team) => team.id === id);
  return teamIds.map(findTeamById);
};

export const sortTeams = (state) => {
  const agentTeams = state.agent_teams;
  const agents = state.visible_agents;
  const userTeamIds = getLoggedInUsersTeamIds(state);

  return state.teams
    .map((team) => {
      const presence = getTeamStatus(team, agentTeams, agents);
      return {
        team: { ...team, presence },
        label: team.name,
        value: `team_${team.id}`,
        presence,
      };
    })
    .sort(sortTeamPresence(userTeamIds));
};

export const teamsSelector = (state) => state.teams;

export const myTeams = (state) => {
  const myTeamIds = state.appState.myTeamIds;
  const teams = state.teams;

  return teams.filter(({ id }) => myTeamIds.includes(id));
};
